import { Moment } from 'jalali-moment';
import { Alert, App } from 'antd';
import { motion, AnimatePresence } from 'motion/react';
import { useSelfContext } from '@/context';
import { Flex, LoadingSpin } from '@/components';
import { useModal } from '@/hooks';
import ReserveCard from './ReserveCard';

export interface ReserveProgramDesktopProps {
  isNewReserveMode?: boolean;
  panelWeekStartDate?: string;
  variant: AppModules;
  programs: SelfMealEntity[];
  groupedPrograms: Dictionary<SelfMealEntity[]>;
  dates: Moment[];
  isProgramsFetching: boolean;
  detailModal: ReturnType<typeof useModal>;
  changeSelfModal: ReturnType<typeof useModal>;
  locked: boolean;
  setLocked: (value: boolean) => any;
}

export default function ReserveProgramDesktop({
  isNewReserveMode = false,
  panelWeekStartDate,
  variant,
  programs,
  groupedPrograms,
  dates,
  isProgramsFetching,
  detailModal,
  changeSelfModal,
  locked,
  setLocked
}: ReserveProgramDesktopProps) {

  const { selfText } = useSelfContext();
  const { message: messageAPI } = App.useApp();

  return (
    <>
      <Flex className="reserve-programs-container reserve-programs-container-desktop" direction="column">
        <Flex className="reserve-programs-content min-h-[200px]" direction="column">
          <AnimatePresence mode="wait">
            {isProgramsFetching ?
              <LoadingSpin className="mt-10" /> :
              <Flex direction="column" className="w-full">
                <motion.div
                  key="program-content"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  className={`week-days-header week-days-header-${variant} sticky top-0 z-10 flex rounded-xl`}>
                  {dates.map((date) => {
                    return (
                      <Flex
                        gap={0}
                        inlineFlex
                        key={date.toISOString()}
                        className="reserve-program-col"
                        direction="column"
                      >
                        <Flex className="week-day-name">
                          <span>
                            {date.clone().format('ddd، jDD jMMM jYYYY')}
                          </span>
                        </Flex>
                      </Flex>
                    );
                  })}
                </motion.div>
                <motion.div
                  className="flex"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 10 }}
                >
                  {Object.entries(groupedPrograms).map(([date, programs], i) => {
                    return (
                      <Flex inlineFlex key={date} className="reserve-program-col" direction="column">
                        {programs.map(meal => (
                          meal.programFoodTypes?.map(reserve => (
                            reserve?.foodList?.map(subFood => (
                              <ReserveCard
                                isNewReserveMode={isNewReserveMode}
                                panelWeekStartDate={panelWeekStartDate}
                                locked={locked}
                                setLocked={setLocked}
                                key={`${i} ${meal.mealTypeId} ${reserve.id} ${reserve.foodNames} ${subFood.id}`}
                                meal={meal}
                                reserve={reserve}
                                messageAPI={messageAPI}
                                onDetailClick={() => detailModal.show({ reserve, meal })}
                                onChangeSelf={() => changeSelfModal.show({ reserve, meal })}
                              />
                            ))
                          ))
                        ))}
                      </Flex>
                    );
                  })}
                </motion.div>
              </Flex>
            }
          </AnimatePresence>
          {!isProgramsFetching && programs.length === 0 && (
            <Flex direction="column" className="w-full text-center">
              <Alert
                type="warning"
                className="flex mx-auto max-h-16 mt-2"
                message={selfText('empty-items')}
              />
            </Flex>
          )}
        </Flex>
      </Flex>
    </>
  );
}
